module.exports = function(bootstrap) {
    bootstrap.run(["Service", "services", function (Service, services) {
        new Service({
            name: 'providerChange',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/providerInfo/change",

            saveData: function(data){

                return this.post({
                    'payload': data
                });
            }
        });
    }]);
};


